import type { Confidence, ResearchQuality } from "../types";

export function ConfidenceBadge({ value, label = "Confidence" }: { value?: Confidence | ResearchQuality | null; label?: string }) {
  return <span className="level-badge"><span className="level-badge-label">{label}</span><strong>{value ? value[0].toUpperCase() + value.slice(1) : "Unavailable"}</strong></span>;
}
